import React from 'react';
import PropTypes from 'prop-types';
import Svg from "../Svg";

const IconServiceSki = ({ fill }) => (
	<div className="icon-service icon-service-ski">
		<Svg width={16} height={14} viewBox={'16 16'}>
			<g strokeWidth="1" transform="translate(-2.0, -1.0)">
				<polygon
					fill="#FEFEFE"
					points="8.302875 0.920776316 9.72222222e-05 4.76248684 9.72222222e-05 6.39182895 8.29315278 2.56946053 16.7125972 6.57603947 16.7125972 4.92735526"
				/>

				<polygon fill="#FEFEFE" points="0 15.6088947 16.7125 15.6088947 16.7125 14.0265263 0 14.0265263"/>

				<g transform="translate(0.000000, 0.872053)">
					<path
						d="M1.88902778,10.1581974 C1.95125,10.6509605 2.47625,10.9668816 3.23166667,10.9668816 C3.92972222,10.9668816 4.42361111,10.6463553 4.42361111,10.1876711 C4.42361111,9.79990789 4.10277778,9.57701316 3.31625,9.41675 L2.48013889,9.24819737 C1.31055556,9.01701316 0.736944444,8.43951316 0.736944444,7.51293421 C0.736944444,6.36714474 1.71111111,5.61280263 3.19180556,5.61280263 C4.60541667,5.61280263 5.60583333,6.36253947 5.64569444,7.44569737 L4.38277778,7.44569737 C4.32055556,6.96490789 3.85,6.64530263 3.20055556,6.64530263 C2.52875,6.64530263 2.08444444,6.94003947 2.08444444,7.40332895 C2.08444444,7.77819737 2.39166667,7.99280263 3.14319444,8.14385526 L3.91611111,8.30043421 C5.20625,8.55740789 5.76138889,9.08425 5.76138889,10.0274079 C5.76138889,11.2533289 4.76972222,12.0030658 3.16069444,12.0030658 C1.63041667,12.0030658 0.639722222,11.2910921 0.591111111,10.1581974 L1.88902778,10.1581974 Z"
						fill="#FEFEFE"/>

					<polygon
						fill="#FEFEFE"
						points="7.48406944 11.8474079 7.48406944 5.76846053 8.82670833 5.76846053 8.82670833 8.47727632 8.90740278 8.47727632 11.2767083 5.76846053 12.7710139 5.76846053 10.4328194 8.43490789 12.9353194 11.8474079 11.3262917 11.8474079 9.46351389 9.30253947 8.82670833 10.0154342 8.82670833 11.8474079"
					/>

					<polygon
						fill="#FEFEFE"
						points="14.4005556 11.8475 15.7431944 11.8475 15.7431944 5.76855263 14.4005556 5.76855263"/>
				</g>
			</g>
		</Svg>
	</div>
);

IconServiceSki.defaultProps = {
	fill: '#ffffff'
};

IconServiceSki.propTypes = {
	fill: PropTypes.string
};

export default IconServiceSki;
